<template>
  <div class="platform-identify" :class="{ 'platform-identify--readonly-view': platformIdentifyReadOnly }">
      <div style="height: 12px" />

      <el-alert v-if="platformIdentifyReadOnly" type="info" :closable="false" show-icon style="margin-bottom: 12px">
        <template slot="title">
          <div>鉴别号：{{ dataInfo.inspectionNo || '-' }}</div>
          <span>当前安心购服务：{{ inspectionServiceTypeLabel(dataInfo.inspectionServiceType) }}</span>
          <div class="platform-identify-service-sub">{{ inspectionServiceTypeHint(dataInfo) }}</div>
        </template>
      </el-alert>
      <el-alert v-else type="info" :closable="false" show-icon style="margin-bottom: 12px">
        <template slot="title">
          <span>当前安心购服务：{{ inspectionServiceTypeLabel(dataInfo.inspectionServiceType) }}</span>
          <div class="platform-identify-service-sub">{{ inspectionServiceTypeHint(dataInfo) }}</div>
        </template>
      </el-alert>

      <el-form class="platform-identify-form" label-width="110px">
        <el-form-item label="平台鉴别">
          <el-radio v-model="ptjbVle" :label="0" :disabled="platformIdentifyReadOnly">需要鉴别</el-radio>
          <el-radio v-model="ptjbVle" :label="1" style="margin-left: 16px"
            :disabled="platformIdentifyReadOnly">不符退回</el-radio>
          <div class="platform-identify-hint">
            需要鉴别：查看图谱并给出真/假结果；不符退回：直接判定不通过并走退回/退款逻辑
          </div>
        </el-form-item>

        <template v-if="ptjbVle === 0">
          <template v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock">
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="标准乙醇">
                  <el-input v-model="identifyBzyc" placeholder="标准乙醇" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="乙醇含量">
                  <el-input v-model="identifyYchl" placeholder="乙醇含量" :disabled="platformIdentifyReadOnly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="标准图谱">
              <div v-if="!platformIdentifyReadOnly" class="platform-identify-actions">
                <uploadFile @getImg="onStdChartNoCoordUploaded" :isSlot="true">
                  <el-button type="success" size="small">更改无坐标图谱</el-button>
                </uploadFile>
                <uploadFile @getImg="onStdChartCoordUploaded" :isSlot="true">
                  <el-button type="success" size="small">更改有坐标图谱</el-button>
                </uploadFile>
              </div>
              <div class="platform-identify-std-preview">
                <div class="platform-identify-std-preview__item">
                  <div class="platform-identify-std-preview__label">无坐标图谱</div>
                  <div class="platform-identify-std-preview__thumb">
                    <el-image v-if="stdChartNoCoord" class="platform-identify-std-preview__img" :src="stdChartNoCoord"
                      fit="contain" :preview-src-list="[stdChartNoCoord]" />
                    <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                  </div>
                </div>
                <div class="platform-identify-std-preview__item">
                  <div class="platform-identify-std-preview__label">有坐标图谱</div>
                  <div class="platform-identify-std-preview__thumb">
                    <el-image v-if="stdChartCoord" class="platform-identify-std-preview__img" :src="stdChartCoord"
                      fit="contain" :preview-src-list="[stdChartCoord]" />
                    <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                  </div>
                </div>
              </div>
              <div class="platform-identify-hint">
                当前：无坐标 {{ stdChartNoCoord ? "已上传" : "未上传" }}；有坐标 {{ stdChartCoord ? "已上传" : "未上传" }}
              </div>
            </el-form-item>

            <el-form-item label="鉴别图谱">
              <div v-if="!platformIdentifyReadOnly" class="platform-identify-chart-mode">
                <el-radio-group v-model="identifyChartUploadMode" size="small">
                  <el-radio-button label="image">上传图片</el-radio-button>
                  <el-radio-button label="txt">TXT 生成谱图</el-radio-button>
                </el-radio-group>
              </div>
              <div v-if="!platformIdentifyReadOnly" class="platform-identify-jbtp-actions">
                <template v-if="identifyChartUploadMode === 'image'">
                  <el-upload class="platform-identify-jbtp-upload" name="file" :show-file-list="false"
                    :action="uploadUrl" :on-success="onIdentifyChartUploaded">
                    <el-button type="success" size="small">{{ identifyList.jbtp ? "更换图片" : "上传图片" }}</el-button>
                  </el-upload>
                </template>
                <template v-else>
                  <el-button type="primary" size="small" plain :loading="identifyTxtGenerating"
                    @click="triggerIdentifySpectrumTxtPick">选择 TXT 并生成谱图</el-button>
                  <input ref="identifySpectrumTxtInput" type="file" accept=".txt,text/plain"
                    class="platform-identify-txt-input" @change="onIdentifySpectrumTxtSelected" />
                </template>
              </div>
              <div class="platform-identify-std-preview platform-identify-jbtp-preview-row">
                <div class="platform-identify-std-preview__item">
                  <div class="platform-identify-std-preview__thumb">
                    <el-image v-if="identifyList.jbtp" class="platform-identify-std-preview__img"
                      :src="identifyList.jbtp" fit="contain" :preview-src-list="[identifyList.jbtp]" />
                    <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                  </div>
                </div>
              </div>
              <div v-if="!inspectIdentifyProfile(dataInfo).requireJbtpWhenNormal" class="platform-identify-hint">
                外观鉴别档：可不传</div>
            </el-form-item>
          </template>

          <el-divider content-position="left">样品信息</el-divider>

          <el-form-item label="类型">
            <el-radio-group v-model.number="identifySffz" :disabled="platformIdentifyReadOnly">
              <el-radio :label="0">分装</el-radio>
              <el-radio :label="1">不分装</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="批次">
            <el-radio-group v-model.number="identifyType2" :disabled="platformIdentifyReadOnly">
              <el-radio :label="0">有批次号</el-radio>
              <el-radio :label="1">无批次号</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="identifyType2 === 0" label="批次号">
            <el-input v-model="identifyBatchNum" placeholder="请输入批次号" maxlength="120" style="max-width: 360px"
              :disabled="platformIdentifyReadOnly"></el-input>
          </el-form-item>

          <el-form-item v-if="identifyRealImgArray.length > 0" label="实物图片" class="platform-identify-real-form-item">
            <div class="image-grid">
              <el-image v-for="(item, index) in identifyRealImgArray" :key="index" :src="item"
                :preview-src-list="identifyRealImgArray"
                style="width: 80px; height: 80px; margin-right: 5px"></el-image>
            </div>
          </el-form-item>

          <el-divider content-position="left">鉴别结果</el-divider>

          <el-form-item label="外观鉴别结果">
            <el-radio v-model="jbjgAppearanceVle" :label="1" :disabled="platformIdentifyReadOnly">通过</el-radio>
            <el-radio v-model="jbjgAppearanceVle" :label="0" style="margin-left: 16px"
              :disabled="platformIdentifyReadOnly">不通过</el-radio>
          </el-form-item>
          <el-form-item
            v-if="String((dataInfo && dataInfo.inspectionServiceType) || '').trim() === 'liq_app'"
            label="液体鉴别结果">
            <el-radio v-model="jbjgLiquidVle" :label="1" :disabled="platformIdentifyReadOnly">通过</el-radio>
            <el-radio v-model="jbjgLiquidVle" :label="0" style="margin-left: 16px"
              :disabled="platformIdentifyReadOnly">不通过</el-radio>
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item label="退回原因">
            <el-radio-group v-model="issueDescChoice" class="issue-desc-radio-group"
              :disabled="platformIdentifyReadOnly">
              <el-radio v-for="item in issueDescOptionList" :key="item.value" :label="item.value"
                class="issue-desc-radio">{{ item.label }}</el-radio>
            </el-radio-group>
            <el-input v-if="issueDescChoice === issueDescCustomValue" v-model="issueDescCustomText" type="textarea"
              :rows="3" maxlength="120" show-word-limit placeholder="请填写具体退回原因" class="issue-desc-custom-input"
              :disabled="platformIdentifyReadOnly" />
          </el-form-item>
        </template>
      </el-form>

      <template v-if="platformIdentifyReadOnly">
        <div style="height: 12px" />
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="订单号">{{ dataInfo && dataInfo.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="安心购服务">{{ inspectionServiceTypeLabel(dataInfo && dataInfo.inspectionServiceType)
            }}</el-descriptions-item>
          <template v-if="ptjbVle === 1">
            <el-descriptions-item label="鉴别结果" :span="2">不符退回/无法鉴别</el-descriptions-item>
            <el-descriptions-item label="退回原因" :span="2">{{ issueDescPreviewText }}</el-descriptions-item>
          </template>
          <template v-else>
            <el-descriptions-item label="外观鉴别">{{ jbjgAppearanceVle === 1 ? '通过' : '不通过' }}</el-descriptions-item>
            <el-descriptions-item v-if="String((dataInfo && dataInfo.inspectionServiceType) || '').trim() === 'liq_app'"
              label="液体鉴别">{{ jbjgLiquidVle === 1 ? '通过' : '不通过' }}</el-descriptions-item>
            <el-descriptions-item label="鉴别结果">{{ previewCombinedInspectionShort }}</el-descriptions-item>
          </template>
          <el-descriptions-item label="批次">{{ previewIdentifyBatchLine }}</el-descriptions-item>
          <el-descriptions-item v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock" label="标准乙醇">{{ identifyBzyc ||
            '-' }}</el-descriptions-item>
          <el-descriptions-item v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock" label="乙醇含量">{{ identifyYchl ||
            '-' }}</el-descriptions-item>
          <el-descriptions-item label="鉴别图谱">{{ identifyList.jbtp ? '已上传' : '未上传' }}</el-descriptions-item>
          <el-descriptions-item label="分装类型">{{ secondhandSffzLabel(identifySffz) }}</el-descriptions-item>
        </el-descriptions>
      </template>

    <span slot="footer" class="dialog-footer" style="display: block; text-align: right; margin-top: 16px;">
      <el-button v-if="!platformIdentifyReadOnly" type="success" :loading="submitLoading"
        @click="submitInspection">提交出具</el-button>
      <el-button @click="handleCancel">关闭</el-button>
    </span>
  </div>
</template>

<script>
import uploadFile from "@/components/elUpload";
import { api } from "@/util/requestUrl";
import {
  SPECTRUM_TXT_MAX_POINTS,
  parseSpectrumTxt,
  downsampleSpectrumPairs,
  renderTxtSpectrumChartToDataUrlAsync,
} from "@/util/spectrumTxtChart";

const ISSUE_DESC_CUSTOM = "custom";

export default {
  components: {
    uploadFile,
  },
  props: {
    orderId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      dataInfo: {},
      submitLoading: false,

      platformIdentifyReadOnly: false,
      platformReportImg: "",

      ptjbVle: 0,
      jbjgAppearanceVle: 1,
      jbjgLiquidVle: 1,

      stdChartNoCoord: "",
      stdChartCoord: "",
      identifyList: {
        jbtp: "",
      },
      identifyChartUploadMode: "image",
      identifyTxtGenerating: false,
      identifySffz: 1,
      identifyType2: 0,
      identifyBatchNum: "",
      identifyYchl: "",
      identifyBzyc: "",

      identifyRealImg: {
        img1: "",
        img2: "",
        img3: "",
        img4: "",
      },

      issueDescChoice: "香水与下单信息不符",
      issueDescCustomText: "",
      issueDescCustomValue: ISSUE_DESC_CUSTOM,

      issueDescOptionList: [
        { value: "香水与下单信息不符", label: "香水与下单信息不符" },
        { value: "严重破损", label: "严重破损" },
        { value: "严重漏液", label: "严重漏液" },
        { value: "喷头损坏，无法取样", label: "喷头损坏，无法取样" },
        { value: ISSUE_DESC_CUSTOM, label: "自定义" },
      ],

      uploadUrl: api.uploadImg,
    };
  },
  computed: {
    realPictureSlots() {
      return [
        { k: "img1", label: "正面" },
        { k: "img2", label: "背面" },
        { k: "img3", label: "顶图" },
        { k: "img4", label: "底图" },
      ];
    },
    identifyRealImgPreviewList() {
      return Object.values(this.identifyRealImg).filter(Boolean);
    },
    issueDescPreviewText() {
      return this.issueDescChoice === ISSUE_DESC_CUSTOM ? this.issueDescCustomText : this.issueDescChoice;
    },
    previewCombinedInspectionShort() {
      if (this.ptjbVle === 1) return "不符退回";
      const appPass = this.jbjgAppearanceVle === 1;
      const liqPass = this.jbjgLiquidVle === 1;
      const isLiqApp = String((this.dataInfo && this.dataInfo.inspectionServiceType) || "").trim() === "liq_app";
      if (isLiqApp) {
        return appPass && liqPass ? "通过" : "不通过";
      }
      return appPass ? "通过" : "不通过";
    },
    previewIdentifyBatchLine() {
      if (Number(this.identifyType2) === 1) return "无批次号";
      return this.identifyBatchNum || "-";
    },
    identifyRealImgArray() {
      let img = [];
      const realpicture = this.dataInfo.realpicture;
      if (realpicture) {
        try {
          const parsedImg = JSON.parse(realpicture);
          if (parsedImg) {
            if (Array.isArray(parsedImg)) {
              img = parsedImg;
            } else if (typeof parsedImg === "object") {
              img = Object.values(parsedImg).filter((v) => v);
            }
          }
        } catch (e) { }
      }
      return img;
    },
  },
  watch: {
    orderId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      this.$https(api.getSecondhandOrderById, {  id: this.orderId, }, "GET").then((res) => {
        if (res.data  === 200) {
          this.dataInfo = res.data.data || {};
          this.openPlatformIdentify();
        } else {
          this.$message.error(res.data.msg || "加载失败");
        }
      });
    },

    /**
     * 打开平台鉴别弹窗：标准图谱优先订单已存列，其次历史 JSON，再其次商品关联型号 Type.atlas1/atlas2
     */
    openPlatformIdentify() {
      if (!this.dataInfo || !this.dataInfo.id) return;
      const d = this.dataInfo;
      const typeId = d.product && d.product.typeId;
      if (typeId) {
        this.$https(api.selType, { id: typeId, page: 1, size: 1 }, "POST")
          .then((res) => {
            let a1 = "";
            let a2 = "";
            let typeBzyc = "";
            if (res.data && Number(res.data.code) === 200 && Array.isArray(res.data.data) && res.data.data.length) {
              const row = res.data.data[0];
              a1 = row.atlas1 != null ? String(row.atlas1).trim() : "";
              a2 = row.atlas2 != null ? String(row.atlas2).trim() : "";
              typeBzyc = row.bzyc != null ? String(row.bzyc).trim() : "";
            }
            this.applyPlatformIdentifyFormState(d, a1, a2, typeBzyc);
          })
          .catch(() => {
            this.applyPlatformIdentifyFormState(d, "", "", "");
          });
      } else {
        this.applyPlatformIdentifyFormState(d, "", "", "");
      }
    },

    /**
     * 安全解析 JSON
     */
    safeJsonParse(str) {
      if (!str) return null;
      try {
        return JSON.parse(String(str));
      } catch (e) {
        return null;
      }
    },

    normalizeChartUrl(url) {
      if (!url) return "";
      const s = String(url).trim();
      if (!s) return "";
      if (/^https?:\/\//i.test(s)) return s;
      const base = "https://hzshixiang.site";
      return s.startsWith("/") ? base + s : base + "/" + s;
    },

    /**
     * 应用平台鉴别表单状态：标准图谱优先级：订单已保存 > JSON报告 > 商品型号
     */
    applyPlatformIdentifyFormState(d, typeAtlas1, typeAtlas2, typeBzyc) {
      if (!d || !d.id) return;

      // 设置只读模式：鉴别结果为 2 时只读
      this.platformIdentifyReadOnly = Number(d.inspectionResult || 0) === 2;
      this.platformReportImg = d.inspectionReportUrl || "";

      // 鉴别结果
      const appIr = d.inspectionResultAppearance;
      const liqIr = d.inspectionResultLiquid;
      if (appIr != null && (appIr === 1 || appIr === 2)) {
        this.jbjgAppearanceVle = appIr === 2 ? 0 : 1;
      } else {
        const ir = Number(d.inspectionResult || 0);
        this.jbjgAppearanceVle = ir === 2 ? 0 : 1;
      }
      if (liqIr != null && (liqIr === 1 || liqIr === 2)) {
        this.jbjgLiquidVle = liqIr === 2 ? 0 : 1;
      } else {
        const ir = Number(d.inspectionResult || 0);
        this.jbjgLiquidVle = ir === 2 ? 0 : 1;
      }

      // 平台鉴别类型
      this.ptjbVle = 0;

      // 标准图谱：优先级 订单已保存 > JSON报告 > 商品型号
      let stdNo = (d.atlas1 && String(d.atlas1).trim()) || "";
      let stdCoord = (d.atlas2 && String(d.atlas2).trim()) || "";

      // 从历史 JSON 中解析
      const payload = this.safeJsonParse(d.inspectionReportJson);
      if (payload && payload.schema === "platform_identify_v1") {
        const ch = payload.charts || {};
        if (!stdNo && ch.stdNoCoord) stdNo = String(ch.stdNoCoord).trim();
        if (!stdCoord && ch.stdCoord) stdCoord = String(ch.stdCoord).trim();
      }

      // 从商品型号获取
      if (!stdNo && typeAtlas1) stdNo = String(typeAtlas1).trim();
      if (!stdCoord && typeAtlas2) stdCoord = String(typeAtlas2).trim();

      this.stdChartNoCoord = this.normalizeChartUrl(stdNo);
      this.stdChartCoord = this.normalizeChartUrl(stdCoord);

      // 鉴别图谱
      let jbtp = (d.jbtp && String(d.jbtp).trim()) || "";
      if (payload && payload.schema === "platform_identify_v1") {
        const ch = payload.charts || {};
        if (!jbtp && ch.identify) jbtp = String(ch.identify).trim();
      }
      this.identifyList = { jbtp: this.normalizeChartUrl(jbtp) };

      // 分装类型
      this.identifySffz = d.sffz != null ? Number(d.sffz) : 1;
      this.identifyType2 = d.type2 != null ? Number(d.type2) : 0;
      this.identifyBatchNum = d.batchNum || "";

      // 标准乙醇和乙醇含量：优先级 订单已保存 > JSON报告 > 商品型号
      let ychl = (d.ychl && String(d.ychl).trim()) || "";
      let bzyc = (d.bzyc && String(d.bzyc).trim()) || "";
      if (payload && payload.schema === "platform_identify_v1" && payload.meta) {
        if (!ychl && payload.meta.ychl) ychl = String(payload.meta.ychl).trim();
        if (!bzyc && payload.meta.bzyc) bzyc = String(payload.meta.bzyc).trim();
      }
      // 从商品型号获取标准乙醇
      if (!bzyc && typeBzyc) bzyc = String(typeBzyc).trim();
      this.identifyYchl = ychl;
      this.identifyBzyc = bzyc;

      // 实物图片
      const real = { img1: "", img2: "", img3: "", img4: "" };
      if (d.realpicture) {
        const rp = typeof d.realpicture === "object" ? d.realpicture : this.safeJsonParse(d.realpicture);
        if (rp && typeof rp === "object") {
          ["img1", "img2", "img3", "img4"].forEach((k) => {
            if (rp[k] != null && String(rp[k]).trim()) real[k] = String(rp[k]).trim();
          });
        }
      }
      this.identifyRealImg = real;

      this.identifyChartUploadMode = "image";
      this.identifyTxtGenerating = false;
    },

    initFormState() {
      // 保留兼容性，内部调用 applyPlatformIdentifyFormState
      this.applyPlatformIdentifyFormState(this.dataInfo, "", "", "");
    },

    inspectIdentifyProfile(detail) {
      const t = String((detail && detail.inspectionServiceType) || "").trim();
      const showLiquidBlock = t === "liq_app";
      const requireJbtpWhenNormal = t === "liq_app";
      return { showLiquidBlock, requireJbtpWhenNormal };
    },

    inspectionServiceTypeLabel(type) {
      const labels = {
        liq_app: "液体鉴别（安心购）",
        appearance_only: "外观鉴别（安心购）",
        app_only: "外观鉴别（安心购）",
      };
      return labels[type] || type || "-";
    },

    inspectionServiceTypeHint(detail) {
      const t = String((detail && detail.inspectionServiceType) || "").trim();
      if (t === "liq_app") return "需同时提供外观鉴别结论 + 液体鉴别结论";
      if (t === "appearance_only") return "仅需提供外观鉴别结论";
      return "";
    },

    secondhandSffzLabel(sffz) {
      return sffz === 0 ? "分装" : "不分装";
    },

    onStdChartNoCoordUploaded(path) {
      this.stdChartNoCoord = this.normalizeChartUrl(path);
    },

    onStdChartCoordUploaded(path) {
      this.stdChartCoord = this.normalizeChartUrl(path);
    },

    onIdentifyChartUploaded(res) {
      const p =
        (res && res.data && res.data.path) ||
        (res && res.data && res.data.data && res.data.data.path) ||
        (res && res.path) ||
        "";
      if (p) {
        this.$set(this.identifyList, "jbtp", this.normalizeChartUrl(p));
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
    },

    triggerIdentifySpectrumTxtPick() {
      this.$refs.identifySpectrumTxtInput && this.$refs.identifySpectrumTxtInput.click();
    },

    onIdentifySpectrumTxtSelected(ev) {
      const input = ev && ev.target;
      if (!input || !input.files || !input.files[0]) return;
      const file = input.files[0];
      input.value = "";
      const name = (file.name || "").toLowerCase();
      if (!name.endsWith(".txt")) {
        this.$message.warning("请选择 .txt 文本文件");
        return;
      }
      this.identifyTxtGenerating = true;
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const text = String(reader.result || "");
          const rawPts = parseSpectrumTxt(text);
          if (rawPts.length < 2) {
            this.identifyTxtGenerating = false;
            this.$message.error("未能从 TXT 中解析出有效数据点，请检查是否为两列数值格式");
            return;
          }
          const pts = downsampleSpectrumPairs(rawPts, SPECTRUM_TXT_MAX_POINTS);
          renderTxtSpectrumChartToDataUrlAsync(pts)
            .then((dataUrl) => this.uploadIdentifyChartFromDataUrl(dataUrl))
            .then(() => {
              this.$message.success("谱图已生成并上传");
            })
            .catch((e) => {
              this.$message.error((e && e.message) || "谱图生成或上传失败");
            })
            .finally(() => {
              this.identifyTxtGenerating = false;
            });
        } catch (err) {
          this.identifyTxtGenerating = false;
          this.$message.error((err && err.message) || "生成谱图失败");
        }
      };
      reader.onerror = () => {
        this.identifyTxtGenerating = false;
        this.$message.error("读取文件失败");
      };
      reader.readAsText(file, "UTF-8");
    },

    dataURLtoFile(base64Str, fileName) {
      const arr = base64Str.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },

    uploadIdentifyChartFromDataUrl(dataUrl) {
      return new Promise((resolve, reject) => {
        const no = new Date().valueOf() + "_" + Math.round(Math.random() * 1000);
        let imgFile;
        try {
          imgFile = this.dataURLtoFile(dataUrl, no + ".png");
        } catch (e) {
          reject(new Error("图片数据转换失败"));
          return;
        }
        const form = new FormData();
        form.append("file", imgFile);
        form.append("no", no);
        this.$https(api.uploadImg, form, "POST")
          .then((res) => {
            const inner = res && res.data;
            const payload = inner && inner.data;
            const p = (payload && payload.path) || (inner && inner.path) || "";
            if (p) {
              this.$set(this.identifyList, "jbtp", this.normalizeChartUrl(p));
              resolve(p);
            } else {
              reject(new Error((inner && inner.msg) || "上传失败"));
            }
          })
          .catch(() => {
            reject(new Error("网络错误"));
          });
      });
    },

    handleCancel() {
      this.$emit("close");
    },

    submitInspection() {
      if (this.platformIdentifyReadOnly) {
        return;
      }

      let inspectionResult;
      if (this.ptjbVle === 1) {
        inspectionResult = 2;
      } else {
        const appPass = this.jbjgAppearanceVle === 1;
        const liqPass = this.jbjgLiquidVle === 1;
        inspectionResult = appPass && liqPass ? 1 : 2;
      }

      const inspectionResultAppearance = this.ptjbVle === 1 ? 2 : (this.jbjgAppearanceVle === 1 ? 1 : 2);
      const inspectionResultLiquid = this.ptjbVle === 1 ? 2 : (this.jbjgLiquidVle === 1 ? 1 : 2);

      const payloadJson = {
        schema: "platform_identify_v1",
        ptjb: this.ptjbVle,
        charts: {
          stdNoCoord: this.stdChartNoCoord,
          stdCoord: this.stdChartCoord,
          identify: this.identifyList.jbtp,
        },
        meta: {
          sffz: this.identifySffz,
          type2: this.identifyType2,
          batchNum: Number(this.identifyType2) === 1 ? "" : String(this.identifyBatchNum || "").trim(),
          ychl: this.identifyYchl,
          bzyc: this.identifyBzyc,
        },
      };

      let issueDesc = null;
      if (this.ptjbVle === 1) {
        issueDesc = this.issueDescChoice === ISSUE_DESC_CUSTOM ? this.issueDescCustomText : this.issueDescChoice;
      }

      this.submitLoading = true;
      this.$https(
        api.submitInspectionReport,
        {
          orderId: this.orderId,
          inspectionResult,
          inspectionResultAppearance,
          inspectionResultLiquid,
          inspectionReportJson: JSON.stringify(payloadJson),
          inspectionIssueType: this.ptjbVle === 1 ? 0 : null,
          inspectionIssueDesc: issueDesc,
          atlas1: this.stdChartNoCoord || "",
          atlas2: this.stdChartCoord || "",
          jbtp: this.identifyList.jbtp || "",
          type2: this.identifyType2,
          batchNum: Number(this.identifyType2) === 1 ? "" : String(this.identifyBatchNum || "").trim(),
          ychl: this.identifyYchl || "",
          bzyc: this.identifyBzyc || "",
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success("提交成功");
            this.$emit("success");
          } else {
            this.$message.error(res.data.msg || "提交失败");
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.platform-identify {
  padding: 0 8px;
}

.platform-identify-form {
  margin-top: 8px;
}

.platform-identify-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  margin-top: 4px;
}

.platform-identify-service-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.platform-identify-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  text-align: center;
}

.platform-identify-std-preview {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 8px;
}

.platform-identify-std-preview__item {
  flex: 1;
}

.platform-identify-std-preview__label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
  text-align: center;
}

.platform-identify-std-preview__thumb {
  max-width: 95%;
  height: 180px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-identify-std-preview__img {
  width: 100%;
  height: 100%;
}

.platform-identify-std-preview__empty {
  color: #c0c4cc;
  font-size: 12px;
}

.platform-identify-chart-mode {
  margin-bottom: 8px;
}

.platform-identify-jbtp-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}

.platform-identify-jbtp-upload {
  display: inline-block;
}

.platform-identify-txt-input {
  display: none;
}

.platform-identify-jbtp-preview-row {
  margin-top: 8px;
}

.platform-identify-real-form-item {
  margin-bottom: 0;
}

.platform-identify-real-strip {
  display: flex;
  gap: 12px;
}

.platform-identify-real-slot {
  text-align: center;
}

.platform-identify-real-slot__cap {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
}

.platform-identify-real-slot__box {
  width: 80px;
  height: 80px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.platform-identify-real-slot__upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-identify-real-slot__empty {
  color: #c0c4cc;
  font-size: 12px;
}

.issue-desc-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.issue-desc-radio {
  margin-left: 0 !important;
}

.issue-desc-custom-input {
  margin-top: 8px;
  max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/inspectionJob/secondHandVerify.vue